import React from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import 'app/component/skeleton/submit/SubmitSkeleton.less';

export interface StepSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;
}

/**
 * Скелетон компонента шага.
 */
export const SubmitSkeleton = (props: StepSkeletonProps) => {
    const className = classNames(
        'submitSkeleton',
        windowTypeToClassName(props.windowType),
    );

    return <Skeleton className={className} visible animate />;
};
